
const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const LISTAR_TRATATIVAS = (state, payload) => {
  state.tratativas = payload
}

const ATUALIZAR_PAGINACAO = (state, payload) => {
  state.paginacao = payload
}

const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

export {
  LISTAR_DADOS,
  LISTAR_TRATATIVAS,
  ATUALIZAR_PAGINACAO,
  BUSCANDO
}